import React, { Fragment } from 'react';
import {
  Datagrid,
  FunctionField,
  NumberField,
  ReferenceManyField,
  useRefresh,
  TextField,
} from 'react-admin';
import CreateButton from '../../EventSuspect/QuickCreate';
import EditButton from '../../EventSuspect/QuickEdit';
import { Pagination } from 'Components';
import { tabbedLists } from 'styles';
import { isSuperAdmin, isAdmin } from 'utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointLeft } from '@fortawesome/pro-regular-svg-icons';

const SuspectsTab = (props) => {
  const classes = tabbedLists();
  const refresh = useRefresh();
  const { record, permissions } = props;
  return (
    <Fragment>
      {(isSuperAdmin(permissions) || isAdmin(permissions)) && (
        <div className={classes.actions}>
          <CreateButton record={record} onChange={() => refresh()} />
        </div>
      )}
      <ReferenceManyField
        reference="eventSuspect"
        target="eventId"
        source="id"
        sort={{ field: 'priorityNumber', order: 'ASC' }}
        perPage={50}
        pagination={<Pagination />}
      >
        <Datagrid>
          <FunctionField label={'Name'}
            render={(record) => <div> {record.name} {record.murderBoxChecked ? <FontAwesomeIcon icon={faHandPointLeft} /> : ''} </div>}
            sortable={false} />
          <NumberField source="priorityNumber" sortable={false} />
          <NumberField source="requiredActors" sortable={false} />
          <FunctionField render={(record) => <EditButton record={record} />} />
        </Datagrid>
      </ReferenceManyField>
    </Fragment>
  );
};

export default SuspectsTab;
